enum TextDecoration {
  EMAIL = "email",
  URL = "url",
  PHONE = "phone",
}

export default TextDecoration;
